<script lang="ts" setup>
  import ButtonQC from '@qicgroupdoha/qic-connect-ds/components/ButtonQC'
  import { WHATSAPP_URL } from './WhatsAppButtonQC.constants'
  import { useLinkTarget } from '@/shared/composables'

  interface Props {
    href?: string
  }
  withDefaults(defineProps<Props>(), {
    href: WHATSAPP_URL,
  })

  const { getLinkTarget } = useLinkTarget()
</script>

<template>
  <ButtonQC
    :href="href"
    class="whatsapp-button-qc"
    data-test="whatsapp-button"
    wide
    icon="whatsapp"
    size="medium"
    :target="getLinkTarget('_blank nofollow noopener')"
  >
    {{ $t('common.whatsapp.button') }}
  </ButtonQC>
</template>

<style lang="scss" scoped>
  .whatsapp-button-qc.ds-base-button--primary {
    background-color: var(--colorBgBtnWhatsappDefaultSolid);

    &:hover:not(:disabled, [aria-disabled='true']) {
      background-color: var(--colorBgBtnWhatsappHoverSolid);
    }
  }
</style>
